export function parseInt(input) {
    const s = String(input);
    const n = Number.parseInt(s);
    if (n.toString() === s && s === input.toString())
        return n;
    return Number.NaN;
}
